import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import { useStripe } from '@stripe/react-stripe-js';
import { Typography } from '@material-ui/core';

import { Loading } from 'components';
import { CREATE_CHECKOUT_SESSION } from 'graphql/account';

export interface CheckoutDetails {
  itunesId: string;
  vanityUrl: string;
  feedUrl: string;
}

const StripeCheckout: React.SFC<CheckoutDetails> = (props) => {
  const { itunesId, vanityUrl, feedUrl } = props;

  const input = { itunesId, vanityUrl, feedUrl };
  const { loading, error, data } = useQuery(CREATE_CHECKOUT_SESSION, { variables: { input } });
  const stripe = useStripe();

  React.useEffect(() => {
    if (!data || !data.createCheckoutSession) return;
    // @ts-ignore
    stripe.redirectToCheckout({ sessionId: data.createCheckoutSession }).then((result: any) => {
      if (result.error) {
        console.log('result.error.message');
        console.log(result.error.message);
      } else {
        console.log('result');
        console.log(result);
      }
    });
  }, [data, stripe]);

  if (loading) return <Loading message="Creating checkout session" />;
  if (error) return <Typography variant="h4">Error getting session: {error}</Typography>;

  return <Loading message="Redirecting you to stripe checkout..." />;
};

export default StripeCheckout;
